import { combineReducers }  from 'redux'

import loginHandler from './loginHandler';
import alertsHandler from './alertsHandler';

export default combineReducers({
    loginHandler,
    alertsHandler
});